export default __webpack_public_path__ + "static/media/Old_Right.2b362a8d.dwg";